<div class="container">
    <div mat-dialog-title>
        {{'testDrive.enterStockNo' | translate}}
    </div>
</div>

<div class="row" mat-dialog-content>
    <label>{{ 'testDrive.stockNo' | translate }}</label>
    <mat-form-field appearance="outline">
    <input matInput [(ngModel)]="data.licensePlate">
    </mat-form-field>
</div>

<div class="row" mat-dialog-actions>
    <div class="controls">
    <button class="cancel" mat-button (click)="onNoClick()">{{'overrideCapacity.cancel' | translate }}</button>
    <button class="save" mat-button [mat-dialog-close]="data" cdkFocusInitial>{{ 'overrideCapacity.save' | translate }}</button>
    </div>
</div>